// extracted by mini-css-extract-plugin
export default {"gameCard":"gameCard_gameCard__77Yhm","slideIn":"gameCard_slideIn__U6VBn","slideOut":"gameCard_slideOut__3Xoqx","rank":"gameCard_rank__gchwl"};